import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/@babel/runtime/helpers/esm/createClass";

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, privateMap, value) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to set private field on non-instance");
  }

  privateMap.set(receiver, value);
  return value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, privateMap) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }

  return privateMap.get(receiver);
};

var _org, _provider;

import TransactionPath from './TransactionPath';
import { calculateTransactionPath } from '../utils/path/calculatePath';
import { describeTransactionPath } from '../utils/descriptions';

var TransactionIntent =
/*#__PURE__*/
function () {
  function TransactionIntent(data, org, provider) {
    _classCallCheck(this, TransactionIntent);

    _org.set(this, void 0);

    _provider.set(this, void 0);

    __classPrivateFieldSet(this, _org, org);

    __classPrivateFieldSet(this, _provider, provider);

    this.contractAddress = data.contractAddress;
    this.functionArgs = data.functionArgs;
    this.functionName = data.functionName;
  }

  _createClass(TransactionIntent, [{
    key: "paths",
    value: function () {
      var _paths = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(account, // eslint-disable-next-line @typescript-eslint/no-unused-vars
      options) {
        var _this = this;

        var apps, _ref, forwardingFeePretransaction, path, describedPath;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __classPrivateFieldGet(this, _org).apps();

              case 2:
                apps = _context.sent;
                _context.next = 5;
                return calculateTransactionPath(account, this.contractAddress, this.functionName, this.functionArgs, apps, __classPrivateFieldGet(this, _provider));

              case 5:
                _ref = _context.sent;
                forwardingFeePretransaction = _ref.forwardingFeePretransaction;
                path = _ref.path;
                _context.next = 10;
                return describeTransactionPath(path, apps, __classPrivateFieldGet(this, _provider));

              case 10:
                describedPath = _context.sent;
                return _context.abrupt("return", new TransactionPath({
                  apps: apps.filter(function (app) {
                    return path.map(function (transaction) {
                      return transaction.to;
                    }).some(function (address) {
                      return address === app.address;
                    });
                  }),
                  destination: apps.find(function (app) {
                    return app.address == _this.contractAddress;
                  }),
                  forwardingFeePretransaction: forwardingFeePretransaction,
                  transactions: describedPath
                }));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function paths(_x, _x2) {
        return _paths.apply(this, arguments);
      }

      return paths;
    }()
  }, {
    key: "transactions",
    value: function () {
      var _transactions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(account, options) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.paths(account, options);

              case 2:
                return _context2.abrupt("return", _context2.sent.transactions);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function transactions(_x3, _x4) {
        return _transactions.apply(this, arguments);
      }

      return transactions;
    }()
  }]);

  return TransactionIntent;
}();

export { TransactionIntent as default };
_org = new WeakMap(), _provider = new WeakMap();